export const ERROR_DATA_DEPARTMENTS = "error_data_gerencia";
export const ERROR_DATA_DEPARTMENTS_ESPECIFIC = "error_data_especific";
export const CREATE_ERROR_DEPARTMENT = "create_error_department";
export const CREATE_ERROR_VEHICLES = "create_error_vehiculos";
export const CREATE_ERROR_POINTS = "create_error_puntos";
export const CREATE_ERROR_OPERATOR = "create_error_operator";
